module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"nu":"now","Välj":"Select","Egenföretagare":"Self-employed","asd":"asd"},"sv":{"nu":"nu","Välj":"Välj","Egenföretagare":"Egenföretagare","asd":"asd"}}')
  delete Component.options._Ctor
}
